import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getUrlParam, isEmpty } from '../../../../helpers/common';
import { figmaConnectRedirect } from '../../../../services/settingServices';
import { ROUTES } from '../../../../routes/urls';
import AppLayout from '../../../../component/appLayout';
import { rootStore } from '../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';

function FigmaConnectRedirect() {
  //mobx states
  const { currentWorkspace } = rootStore.workspaceStore;

  // Other variables
  const history = useHistory();
  const code = getUrlParam(history.location.search, 'code');
  const state = getUrlParam(history.location.search, 'state');

  const loadData = useCallback(async () => {
    if (!isEmpty(currentWorkspace?.id)) {
      const paramsObj = {
        state: isEmpty(state) ? undefined : state,
        code: code
      };
      await figmaConnectRedirect(paramsObj);
      history.push(ROUTES.INTEGRATIONS_SETTING);
    }
  }, [code, history, state, currentWorkspace?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  return <AppLayout>Loading ...</AppLayout>;
}

export default observer(FigmaConnectRedirect);
